import React, { useEffect, useState } from "react";
import { Card, Col, Table, Tabs, Tab, Dropdown, Modal, Form, Button } from "react-bootstrap";
import {
  assignPlan,
  changeNewWeddingSubscription,
  changeRequestUserPlan,
  changeSUBSCRIPTION,
  editHostSubscription,
  getNEWUSERS,
  getSUBSCRIPTION,
} from "../../services/UserServices/UserService";
import toast from "react-hot-toast";
import Lottie from "lottie-react";
import animationData from "../../images/loding.json";
import Pagination from "../components/Pagination";
import { useNavigate } from "react-router-dom";

export default function ContactAdminNewUser() {
  const [key, setKey] = useState("contactAdmin");
  const [search, setSearch] = useState("");
  const [newUser, setNewUser] = useState([]);
  const [contactAdmin, setContactAdmin] = useState([]);
  const [loader, setLoader] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [plans, setPlans] = useState([]);
  const [assignPlanId, setAssignPlanId] = useState("");
  const [assignPlanLoading, setAssignPlanLoading] = useState(false);

  const getNewUsers = async () => {
    try {
      setLoader(true);
      const response = await getNEWUSERS(currentPage, itemsPerPage, search, key);
      const users = response?.data?.data?.users || [];
      const count = response?.data?.data?.count || 0;

      if (key === "contactAdmin") {
        setContactAdmin(users);
      } else {
        setNewUser(users);
      }

      setTotalItems(count);
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getNewUsers();
  }, [search, key, currentPage]);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const res = await getSUBSCRIPTION();
        setPlans(res?.data?.data || []);
      } catch (error) {
        console.error("Error fetching subscriptions:", error);
      }
    };

    fetchSubscription();
  }, []);

  const handleTabChange = (k) => {
    setKey(k);
    setSearch("");
    setCurrentPage(0);
    setTotalItems(0);
    setNewUser([]);
    setContactAdmin([]);
  };

  const handleApproval = async (id, status) => {
    try {
      const payload = {
        userId: id,
        adminApproval: status,
      };
      await changeSUBSCRIPTION(payload);

      getNewUsers();

      if (status === "accepted") {
        toast.success("Approved Successfully!");
      } else {
        toast.success("Disapproved Successfully!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleApprovalNewUser = async (id, status) => {
    try {
      const payload = {
        userId: id,
        adminApproval: status,
      };
      await changeNewWeddingSubscription(payload);

      getNewUsers();

      if (status === "accepted") {
        toast.success("Approved Successfully!");
      } else {
        toast.success("Disapproved Successfully!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
  };

  const activeList = key === "contactAdmin" ? contactAdmin : newUser;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const openChangePlanModal = (user) => {
    setSelectedUser(user);
    setAssignPlanId(user?.plan?._id || user?.plan?.id || user?.subscriptionId || "");
    setShowPlanModal(true);
  };

  const handleClosePlanModal = () => {
    setShowPlanModal(false);
    setSelectedUser(null);
    setAssignPlanId("");
  };

  const handleAssignPlanSubmit = async (e) => {
    e.preventDefault();
    if (!assignPlanId) {
      toast.error("Please select a plan");
      return;
    }
    try {
      setAssignPlanLoading(true);
      const userId = selectedUser?._id || selectedUser?.id;
      const payload = {
        userId,
        subscriptionId: assignPlanId,
      };
      try {
        await editHostSubscription(payload);
      } catch (err) {
        await changeRequestUserPlan(payload);
      }
      toast.success("Plan assigned successfully!");
      handleClosePlanModal();
      getNewUsers();
    } catch (error) {
      console.error("Error assigning plan:", error);
      toast.error(error?.response?.data?.message || "Failed to assign plan");
    } finally {
      setAssignPlanLoading(false);
    }
  };

  return (
    <div className="qx-page">
      {/* ASSIGN PLAN MODAL */}
      <Modal show={showPlanModal} onHide={handleClosePlanModal} centered>
        <Modal.Header closeButton style={{ borderBottom: "1px solid #F8DBA0" }}>
          <Modal.Title style={{ color: "#800001", fontWeight: "700" }}>
            Assign Plan - {selectedUser?.name || selectedUser?.hostName || selectedUser?.phoneNumber || "User"}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleAssignPlanSubmit}>
          <Modal.Body className="py-4">
            {selectedUser?.plan?.name && (
              <p className="mb-3 text-secondary">
                Current Plan: <strong>{selectedUser.plan.name}</strong>
              </p>
            )}
            <Form.Group className="mb-3">
              <Form.Label style={{ color: "#800001", fontWeight: "700" }}>
                Select Subscription Plan *
              </Form.Label>
              <Form.Select
                value={assignPlanId}
                onChange={(e) => setAssignPlanId(e.target.value)}
                style={{ borderColor: "#F8DBA0", borderRadius: "0.75rem" }}
                required
              >
                <option value="">-- Select Subscription Plan --</option>
                {plans?.map((plan) => (
                  <option key={plan._id || plan.id} value={plan._id || plan.id}>
                    {plan?.name} {plan?.price !== undefined ? `(₹${plan.price})` : ""}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "1px solid #F8DBA0" }}>
            <Button
              variant="secondary"
              onClick={handleClosePlanModal}
              disabled={assignPlanLoading}
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: "#A60000", borderColor: "#A60000", color: "#FFB101", fontWeight: "800" }}
              type="submit"
              disabled={assignPlanLoading}
            >
              {assignPlanLoading ? "Assigning..." : "Assign Plan"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <div className="mb-2 position-relative">
        <input
          type="text"
          className="form-control inpp pe-5"
          style={{ borderRadius: "0.5rem" }}
          placeholder="Search by phone number"
          value={search}
          onChange={handleSearch}
        />

        {search && (
          <button
            type="button"
            onClick={() => {
              setSearch("");
            }}
            className="btn position-absolute top-50 end-0 translate-middle-y me-2"
            style={{
              border: "none",
              background: "transparent",
              fontSize: "1.2rem",
              cursor: "pointer",
            }}
          >
            ❌
          </button>
        )}
      </div>

      {loader ? (
        <div>
          <Lottie
            style={{
              height: "200px",
              marginTop: "45px",
              padding: "30px",
            }}
            animationData={animationData}
          />
        </div>
      ) : activeList && activeList.length > 0 ? (
        <Col>
          <Card className="qx-table-card">
            <Card.Body>
              <Table responsive className="mb-0">
                <thead>
                  <tr>
                    <th>
                      <strong>S.NO</strong>
                    </th>
                    <th>
                      <strong>Phone</strong>
                    </th>
                    <th>
                      <strong>Requested Date</strong>
                    </th>
                    <th>
                      <strong>Action</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {activeList.map((user, index) => (
                    <tr key={user?._id} style={{ color: "#A60000" }}>
                      <td>{index + 1 + currentPage * 10}</td>
                      <td>{user?.countryCode} {user?.phoneNumber}</td>
                      <td>
                        {new Date(user?.createdAt).toLocaleDateString("en-IN", {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true
                        })}
                      </td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="info light"
                            className="light sharp btn btn-info i-false"
                          >
                            {svg1}
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item onClick={() => openChangePlanModal(user)}>
                              Assign Plan
                            </Dropdown.Item>


                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {activeList.length > 0 && (
                <Pagination
                  pageCount={totalPages}
                  pageValue={currentPage}
                  setPage={setCurrentPage}
                  total={totalItems}
                  pageSize={itemsPerPage}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      ) : (
        <div style={{ height: "40vh" }} className="d-flex flex-column justify-content-center align-items-center py-5 text-center">
          <p style={{ color: "#A60000", textAlign: "center" }}>
            Data not found
          </p>
        </div>
      )}
    </div>
  );
}
